import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';
import {P} from './factory.js';
import Row from './row';
import Section from './section';

import './cookies-info.less';

export const CookiesInfo = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.CookiesInfo',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'smallBox'),
    classNames: {
      main: 'uu5-bricks-cookies-info'
    },
    opt: {
      nestingLevelRoot: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    data: React.PropTypes.shape({
      header: React.PropTypes.any,
      chapters: React.PropTypes.arrayOf(
        React.PropTypes.shape({
          header: React.PropTypes.any,
          // array of contents
          rows: React.PropTypes.arrayOf(React.PropTypes.any)
        })
      )
    }),
    headerLevel: React.PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', 0, 1, 2, 3, 4, 5, 6]),
    chapterLevel: React.PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', 0, 1, 2, 3, 4, 5, 6])
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      data: {},
      headerLevel: 1,
      chapterLevel: 2
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getChapters: function (chaptersData) {
    var collection = this;
    return chaptersData && chaptersData.map(function (chapter, i) {
        var paragraphs = chapter.rows.map(function (content, j) {
          return (
            <P content={content} key={j}/>
          )
        });

        return (
          <Row header={chapter.header} key={i} level={collection.props.chapterLevel}>
            {paragraphs}
          </Row>
        )
      });
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var data = this.props.data;
    var chapters = this._getChapters(data.chapters);

    return (
      <Section
        {...this.getMainPropsToPass()}
        header={data.header}
        level={this.props.headerLevel}
        nestingLevel={this.getNestingLevel()}
      >
        {chapters}
      </Section>
    );
  }
  //@@viewOff:render
});

export default CookiesInfo;



// WEBPACK FOOTER //
// ./bricks/cookies-info.js